import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserEnterpriseInfoViewModel } from '@/app/proxy/proxies';

@Component({
  selector: 'app-home-header',
  imports: [SharedModule],
  templateUrl: './home-header.component.html',
  styleUrl: './home-header.component.less',
})
export class HomeHeaderComponent {
  @Input() userEnterprises: UserEnterpriseInfoViewModel[] = [];
  @Input() selectedEnterprise: UserEnterpriseInfoViewModel;
  @Input() loadingEnterprises = false;
  @Output() readonly selectEnterpriseEvent = new EventEmitter<UserEnterpriseInfoViewModel>();

  constructor() {}

  onSelectEnterpriseChange(event: UserEnterpriseInfoViewModel) {
    this.selectedEnterprise = event;
    this.selectEnterpriseEvent.emit(this.selectedEnterprise);
  }
}
